var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.022 100.004C100.022 116.221 100.022 132.438 100.022 148.658C100.022 153.047 98.3356 155.994 94.8461 157.315C91.0134 158.771 87.8368 157.622 85.0034 154.78C75.3911 145.138 65.6961 135.569 56.0664 125.945C55.2711 125.15 54.4889 124.843 53.3721 124.852C46.9233 124.9 40.4745 124.882 34.0214 124.874C28.6502 124.865 25.0869 121.487 25.0521 116.156C24.9869 105.383 24.9869 94.6047 25.0521 83.8311C25.0869 78.4918 28.6459 75.1397 34.0344 75.131C40.5397 75.1224 47.0406 75.1094 53.546 75.1483C54.5454 75.1526 55.2407 74.8632 55.9534 74.1591C65.7439 64.3833 75.5519 54.6335 85.3772 44.8924C88.7624 41.5359 93.1383 41.0823 96.6843 43.7174C99.0179 45.4496 100.035 47.8212 100.03 50.7112C100.009 67.1437 100.022 83.5762 100.022 100.009V100.004Z",
    fill: "url(#paint0_linear_25_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 102.873C174.687 122.459 166.813 141.82 151.13 157.993C147.514 161.721 142.487 162.002 138.975 158.702C135.447 155.388 135.442 150.213 139.106 146.477C146.528 138.9 152.138 130.191 155.115 120.039C162.302 95.5505 157.292 73.6966 140.157 54.6592C138.449 52.7585 136.642 50.996 136.42 48.2486C136.12 44.5206 137.88 41.3369 141.165 39.8163C144.464 38.2871 148.062 38.9264 150.717 41.5874C157.687 48.5726 163.28 56.521 167.413 65.4716C172.48 76.444 174.965 87.9735 174.996 102.877L175 102.873Z",
    fill: "url(#paint1_linear_25_513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.678 100.065C141.47 113.517 136.755 125.133 127.329 134.835C124.926 137.306 122.032 138.148 118.738 137.176C115.427 136.2 113.484 133.867 112.898 130.502C112.398 127.629 113.445 125.232 115.448 123.18C119.768 118.756 122.788 113.577 124.083 107.542C126.569 95.9954 123.792 85.7964 115.692 77.1135C113.497 74.7592 112.237 72.1933 113.019 68.9232C113.758 65.8388 115.657 63.7567 118.682 62.8366C121.697 61.9208 124.539 62.4564 126.808 64.6898C135.099 72.8542 139.918 82.7293 141.335 94.2502C141.57 96.1812 141.704 98.1078 141.678 100.065Z",
    fill: "url(#paint2_linear_25_513)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_513",
    x1: 62.5168,
    y1: 42.0166,
    x2: 62.5168,
    y2: 157.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_513",
    x1: 155.672,
    y1: 39.001,
    x2: 155.672,
    y2: 160.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_513",
    x1: 127.228,
    y1: 62.4106,
    x2: 127.228,
    y2: 137.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 122,
    fill: "white",
    transform: "translate(25 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioSound);
export default __webpack_public_path__ + "static/media/Audio_&_Sound.9f9e16c1bc31d9d6950d8213509eb05a.svg";
export { ForwardRef as ReactComponent };